// Color coding templates for Table and Crosstab visualizations.
// v1 templates are fixed (read-only) and defined centrally in
// `@_constants/color-coding-templates`. See color-coding utils for the
// metric-type derivation and range-matching logic.

export type ColorCodingMetricType = "mean" | "proportion";

// Sentinel template id meaning "no color coding".
export const COLOR_CODING_NONE = "none";

export interface ColorCodingRange {
  // Display label for the bucket (e.g. "Resilient").
  label: string;
  // Legend boundary text exactly as defined by the template (e.g. "80+", "Below 50").
  boundaryText: string;
  // Inclusive lower/upper bounds against the half-up-rounded integer value.
  // Use -Infinity / Infinity for open-ended buckets.
  min: number;
  max: number;
  // Cell background color.
  bgColor: string;
  // Cell text color.
  textColor: string;
  // Whether the cell text is bold.
  bold: boolean;
}

export interface ColorCodingTemplate {
  id: string;
  displayName: string;
  metricType: ColorCodingMetricType;
  ranges: ColorCodingRange[];
}
